// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../rescript/lib/es6/list.js";
import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Caml_obj from "../../../../rescript/lib/es6/caml_obj.js";
import * as Caml_option from "../../../../rescript/lib/es6/caml_option.js";
import * as Caml_js_exceptions from "../../../../rescript/lib/es6/caml_js_exceptions.js";

function slice(list, start, range) {
  var drop = function (_n, _list) {
    while(true) {
      var list = _list;
      var n = _n;
      if (!list) {
        return /* [] */0;
      }
      if (n === 0) {
        return list;
      }
      _list = list.tl;
      _n = n - 1 | 0;
      continue ;
    };
  };
  var take = function (n, list) {
    if (list && n !== 0) {
      return {
              hd: list.hd,
              tl: take(n - 1 | 0, list.tl)
            };
    } else {
      return /* [] */0;
    }
  };
  return take(range, drop(start, list));
}

function find(lst, fn) {
  try {
    return Caml_option.some(List.find(fn, lst));
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === "Not_found") {
      return ;
    }
    throw exn;
  }
}

function findIndex(_iOpt, _lst, f) {
  while(true) {
    var iOpt = _iOpt;
    var lst = _lst;
    var i = iOpt !== undefined ? iOpt : 0;
    if (!lst) {
      return ;
    }
    if (Curry._1(f, lst.hd)) {
      return i;
    }
    _lst = lst.tl;
    _iOpt = i + 1 | 0;
    continue ;
  };
}

function getElementAt(_index, _l) {
  while(true) {
    var l = _l;
    var index = _index;
    if (!l) {
      return ;
    }
    if (index <= 0) {
      return Caml_option.some(l.hd);
    }
    _l = l.tl;
    _index = index - 1 | 0;
    continue ;
  };
}

function calculateSum(l) {
  if (l) {
    return l.hd + calculateSum(l.tl) | 0;
  } else {
    return 0;
  }
}

function calculateSumForFloats(l) {
  if (l) {
    return l.hd + calculateSumForFloats(l.tl);
  } else {
    return 0;
  }
}

function removeItem(value, _l) {
  while(true) {
    var l = _l;
    if (!l) {
      return /* [] */0;
    }
    var tail = l.tl;
    var head = l.hd;
    if (!Caml_obj.caml_equal(head, value)) {
      return {
              hd: head,
              tl: removeItem(value, tail)
            };
    }
    _l = tail;
    continue ;
  };
}

function replaceItem(value, with_, l) {
  if (!l) {
    return /* [] */0;
  }
  var tail = l.tl;
  var head = l.hd;
  if (Caml_obj.caml_equal(head, value)) {
    return {
            hd: with_,
            tl: replaceItem(value, with_, tail)
          };
  } else {
    return {
            hd: head,
            tl: replaceItem(value, with_, tail)
          };
  }
}

function range(start, end_) {
  if (start >= end_) {
    return /* [] */0;
  } else {
    return {
            hd: start,
            tl: range(start + 1 | 0, end_)
          };
  }
}

function unique(list_input) {
  var _new_list = /* [] */0;
  var _old_list = list_input;
  while(true) {
    var old_list = _old_list;
    var new_list = _new_list;
    if (!old_list) {
      return List.rev(new_list);
    }
    var tail = old_list.tl;
    var head = old_list.hd;
    if (List.exists((function(head){
          return function (list_item) {
            return Caml_obj.caml_equal(list_item, head);
          }
          }(head)), new_list)) {
      _old_list = tail;
      continue ;
    }
    _old_list = tail;
    _new_list = {
      hd: head,
      tl: new_list
    };
    continue ;
  };
}

function prev(value, _list, comparisonFunction) {
  while(true) {
    var list = _list;
    if (!list) {
      return ;
    }
    var match = list.tl;
    if (!match) {
      return ;
    }
    var head = match.hd;
    if (Curry._2(comparisonFunction, head, value)) {
      return Caml_option.some(list.hd);
    }
    _list = {
      hd: head,
      tl: match.tl
    };
    continue ;
  };
}

function pop(value, lst, comparisonFunction) {
  var _returnlstOpt;
  var _list = lst;
  while(true) {
    var returnlstOpt = _returnlstOpt;
    var list = _list;
    var returnlst = returnlstOpt !== undefined ? returnlstOpt : /* [] */0;
    if (!list) {
      return List.rev(returnlst);
    }
    var tail = list.tl;
    var head = list.hd;
    if (!tail) {
      if (Curry._2(comparisonFunction, head, value)) {
        return List.rev(returnlst);
      } else {
        return List.rev({
                    hd: head,
                    tl: returnlst
                  });
      }
    }
    if (Curry._2(comparisonFunction, head, value)) {
      return List.append(List.rev(returnlst), tail);
    }
    _list = tail;
    _returnlstOpt = {
      hd: head,
      tl: returnlst
    };
    continue ;
  };
}

function toString(lst, convertFun, delimeterOpt, param) {
  var delimeter = delimeterOpt !== undefined ? delimeterOpt : ",";
  var join = function (lst, delimeter) {
    if (!lst) {
      return "";
    }
    var tail = lst.tl;
    var head = lst.hd;
    if (tail) {
      return Curry._1(convertFun, head) + (delimeter + (" " + join(tail, delimeter)));
    } else {
      return Curry._1(convertFun, head);
    }
  };
  return join(lst, delimeter);
}

export {
  slice ,
  find ,
  findIndex ,
  getElementAt ,
  calculateSum ,
  calculateSumForFloats ,
  removeItem ,
  replaceItem ,
  range ,
  unique ,
  prev ,
  pop ,
  toString ,
  
}
/* No side effect */
